export class RecollectionResponse {
    contractNumber: string;
	compCode: number;
	documents: Array<string>;

    constructor(){
        this.contractNumber = "";
	    this.compCode = 0;
	    this.documents = Array<string>();
    }
}